module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki16_pc-32c9cb037e0f3ff99fd7f27170481e2f.jpg";